import { useEffect, useState } from 'react';
import Api from '../api';

export interface PromotionEligibilityStatus {
    eligible: boolean;
    daysRemaining: number;
    promotionEndDate: string | null;
}

/**
 * Keeps OfficePromotion pricing scoped to the currently selected location.
 * Clearing on every location change prevents a previous office's promotion
 * from remaining visible while the new request is in flight.
 */
export default function usePromotionEligibilityStatus(
    locationId?: number | string | null,
): PromotionEligibilityStatus | null {
    const [status, setStatus] = useState<PromotionEligibilityStatus | null>(null);

    useEffect(() => {
        const normalizedId = Number(locationId);
        let active = true;
        setStatus(null);

        if (!normalizedId || Number.isNaN(normalizedId)) {
            return () => { active = false; };
        }

        Api.getPromotionEligibilityStatus(normalizedId)
            .then(response => {
                if (!active) return;
                setStatus({
                    eligible: !!response?.eligible,
                    daysRemaining: Number(response?.daysRemaining || 0),
                    promotionEndDate: response?.promotionEndDate || null,
                });
            })
            .catch(() => {
                if (active) setStatus(null);
            });

        return () => { active = false; };
    }, [locationId]);

    return status;
}
